import { Component, OnInit, Input, HostListener } from '@angular/core';

@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.scss']
})
export class HeaderOneComponent implements OnInit {
  @Input() class: string;
  @Input() themeLogo: string = 'assets/img/newlogo/ONESB-LOGO-OG.png'; // Default Logo
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  isScrolled = false;
  public stick: boolean = false;
  isMobile = false;
  showNotification = true;
  constructor() { }
  menuOpen=false;
  mobilemenuOpen=false;
  ngOnInit() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }
  
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    const navbar = document.getElementById('navbarNav');
    if (navbar) {
      if (this.menuOpen) {
        navbar.classList.add('show');  // Bootstrap uses 'show' class to open collapse
      } else {
        navbar.classList.remove('show');
      }
    }
  }
  toggleMobileMenu() {
   
    this.mobilemenuOpen = !this.mobilemenuOpen;
  }
  closeNotification() {
    this.showNotification = false;
  }
  isBoldTitle(title: string): boolean {
    const boldTitles = ['UNDER GRADUATE', 'POST GRADUATE', 'DOCTORATE'];
    return boldTitles.includes(title.toUpperCase());
  }
  

  menu = [
    {
      title: 'ABOUT US',
      link: '/about-us',
      expanded: false,
      children: [{ title: 'ABOUT US',link:'/about-us' }, { title: 'MENTORS',link:'/mentors' }, {title: 'COLLEGE COMMITTEE',link:'/college-committee'}, {title: 'VISSION MISSION',link:'/vision-mission'} , {title: 'CORPORATES',link:'/corporates'}]
    },
    {
      title: 'PROGRAMS',
      link: '/program',
      expanded: false,
      children: [{ title: 'UNDER GRADUATE',link:'/courses/ug/bba-prime/overview', isBold:true }, 
        { title: 'BBA PRIME',link:'/courses/ug/bba-prime/overview' },
       /*  { title: 'BBA in Business Analytics',link:'/courses/ug/bba-prime/overview' },{ title: 'BBA in Digital Marketing',link:'/courses/ug/bba-prime/overview' },{ title: 'BBA in Logistics & Supplychain',link:'/courses/ug/bba-prime/overview' }, */

        { title: 'BBA GLOBAL',link:'/courses/ug/bba-global/overview' },
       /*  { title: 'BBA in Business Analytics',link:'/courses/ug/bba-global/overview' },{ title: 'BBA in Digital Marketing',link:'/courses/ug/bba-global/overview' },{ title: 'BBA in Logistics & Supplychain',link:'/courses/ug/bba-global/overview' }, */

       

       /*  { title: 'UNDER GRADUATE',link:'/courses/ug/bca-prime/overview' },  */
        { title: 'BCA PRIME',link:'/courses/ug/bca-prime/overview' },
        /* { title: 'BCA Cyber Security & Ethical Hacking',link:'/courses/ug/bca-prime/overview' },{ title: 'BCA Data Analytics',link:'/courses/ug/bca-prime/overview' },{ title: 'BCA Artificial Intelligence & Machine Learning',link:'/courses/ug/bca-prime/overview' }, */

        { title: 'BCA GLOBAL',link:'/courses/ug/bca-global/overview' },
       /*  { title: 'BCA Cyber Security & Ethical Hacking',link:'/courses/ug/bca-global/overview' },{ title: 'BCA Data Analytics',link:'/courses/ug/bca-global/overview' },{ title: 'BCA Artificial Intelligence & Machine Learning',link:'/courses/ug/bca-global/overview' }, */

        { title: 'POST GRADUATE',link:'/courses/pg/mba-prime/overview',isBold:true }, 
        { title: 'MBA PRIME',link:'/courses/pg/mba-prime/overview' }, { title: 'MBA Catalyst',link:'/courses/pg/mba-catalyst/overview' },  { title: 'MBA Pinnacle',link:'/courses/pg/mba-pinnacle/overview' },

       
      
        { title: 'DOCTORATE',link:'/courses/doctrate/doctorate/overview',isBold:true },
      ]
    },
    {
      title: 'ADMISSIONS & FINANCIAL AID',
      link: '/admission-financial',
      expanded: false,
      children: [{ title: 'ADMISSIONS',link:'/admission-financial' }, { title: 'FINANCIAL AID',link:'/admission-financial' }, {title: 'STUDENT SERVICES' ,link:'/admission-financial'}]
    },
    {
      title: 'LIFE AT ONESB',
      link: '/campus-life',
      expanded: false,
      children: [{ title: 'CAMPUS LIFE' ,link:'/campus-life'}, {title:'STUDENTS & ALUMNI STORIES',link:'/students-alumni'}, {title: 'CHAT WITH OUR STUDENTS AND STAFF',link:'/chat-students-staff' }]
    },
    {
      title: 'FACULTY & RESEARCH',
      link: '/faculty',
      expanded: false,
      children: [{ title: 'FACULTY' ,link:'/faculty'}, { title: 'RESEARCH'  ,link:'/research'}]
    },
    {
      title: 'PLACEMENT & STARTUPS',
      link: '/placement',
      expanded: false,
      children: [{title: 'PLACEMENTS' ,link:'/placement'},{title: 'OUR RECRUITERS' ,link:'/our-recruiters'},{title: 'ARTIFICIAL INTELLIGENCE LAB' ,link:'/ai-lab'},{title: 'MENTORSHIP PROGRAM' ,link:'/mentorship'},{title: 'TECH VENTURE BOOTCAMP' ,link:'/tech-venture'},] 
    }
  ];
  MENUITEMS = [
    {
      title: "Home",
      path: "/",
      type: "link",
      active: false,
    },
    {
      title: "About us",
      type: "sub",
      active: false,
      children: [
        { path: "/about-us", title: "About us", type: "link" },
        { path: "/vision-mission", title: "Vision Mission", type: "link" },
        {
          title: "Committee",
          type: "sub",
          children: [
            {
              title: "College Committee",
              type: "link",
              path: "/college-committee",
            },
          ],
        },
        { path: "/mentors", title: "Mentors", type: "link" },
        { path: "/corporates", title: "Corporates", type: "link" },
      ],
    },
    {
      title: "Programme",
      type: "sub",
      active: false,
      children: [
        {
          title: "UG Programme",
          type: "sub",
          children: [
            { path: "/course/BBA", title: "BBA", type: "link" },
            { path: "/course/BBA-Aviation", title: "BBA Aviation", type: "link" },
          ],
        },
        {
          title: "PG Programme",
          type: "sub",
          children: [

            {path: "/course/mba-prime", title: "MBA Prime", type: "link"},
            {path: "/course/mba-catalyst", title:"MBA Catalyst", type: "link"},
            {path: "/course/mba-pinnacle", title: "MBA Pinnacle + PCIP", type: "link"}
            /* { path: "/course/MBA-international", title: "MBA international", type: "link" },
            { path: "/course/MBA-Global", title: "MBA Global", type: "link" },
            { path: "/course/MBA-Advance", title: "MBA Advance", type: "link" }, */
          ],
        },
        {
          title: "Doctorate",
          path: "/doctorate",
          type:"link",
          active: false,
        
        },
        {
          title: "Certification Programme",
          path:"/certification-programme"
          
          /*type: "sub", 
            children: [
            { path: "/course/CBAP", title: "CBAP", type: "link" },
            { path: "/course/CFM", title: "CFM", type: "link" },
            { path: "/course/CHRAP", title: "CHRAP", type: "link" },
            { path: "/course/CAT", title: "CAT", type: "link" },
            { path: "/course/CMAP", title: "CMAP", type: "link" },
            { path: "/course/CLM", title: "CLM", type: "link" },
            { path: "/course/CAI", title: "CAI", type: "link" },
            { path: "/course/CDM", title: "CDM", type: "link" },
            { path: "/course/CBA", title: "CBA", type: "link" },
            { path: "/course/CMIS", title: "CMIS", type: "link" },
          ], */
        },
      ],
    },
    {
      title: "Admission",
      path: "/admission",
      type: "link",
      active: false,
    },
    {
      title: "Life @ONESB",
      path: "/student-life",
      type: "sub",
      active: false,
      children: [
        { path: "/student-life", title: "Student life", type: "link" },
      ],
    },
    {
      title: "Gallery",
      type: "sub",
      active: false,
      children: [
        { path: "/onam", title: "Onam", type: "link" },
        { path: "/sports", title: "Sports", type: "link" },
        { path: "/library", title: "Library", type: "link" },
        { path: "/annual", title: "Annual Day", type: "link" },
        { path: "/kannadostva", title: "Kannadostva", type: "link" },
      ],
    },
    {
      title: "Finishing School",
      path: "/finishing-school",
      type: "link",
      active: false,
    },
    {
      title: "Center Of Excellence",
      path: "/center-of-excellence",
      type: "link",
      active: false,
    },
    {
      title: "Placements",
      type: "sub",
      active: false,
       path: "/placement-overview",
    },
  ];
  toggleSection(section: any) {
    section.expanded = !section.expanded;
  }
  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  	if (number >= 150 && window.innerWidth > 400) { 
  	  this.stick = true;
  	} else {
  	  this.stick = false;
  	}

    this.isScrolled = window.pageYOffset > 50;
  }

}
